import { Coordinates } from "./tree-models";
import TreeNode from "./tree-node";

export default class TreeLink {
  protected static readonly htmlClass: string = "tree-link";

  private angle: number; // rad
  // all dimensions and positions are in pixels
  private length: number;
  protected start: Coordinates;
  protected end: Coordinates;

  constructor(nodeA: TreeNode, nodeB: TreeNode, startOffset = { x: 0, y: 0 }, endOffset = { x: 0, y: 0 }) {
    this.angle = undefined;
    this.length = undefined;

    this.start = {
      x: nodeA.position.x + nodeA.clientSize.width + startOffset.x,
      y: nodeA.position.y + startOffset.y,
    };
    this.end = {
      x: nodeB.position.x + endOffset.x,
      y: nodeB.position.y + endOffset.y,
    };
  }

  /**
   * getLength
   * Self-explanatory. The length is in pixels. The calculation is performed only once, then cached.
   *
   * @param {void}
   * @returns {number}
   */
  private getLength(): number {
    if (this.length === undefined) {
      this.length = Math.sqrt((this.start.x - this.end.x) ** 2 + (this.start.y - this.end.y) ** 2);
    }

    return this.length;
  }

  /**
   * getLength
   * Self-explanatory. The angle is in radians. The calculation is performed only once, then cached.
   *
   * @param {void}
   * @returns {number}
   */
  private getAngle() {
    if (this.angle === undefined) {
      this.angle = Math.acos(Math.abs(this.start.x - this.end.x) / this.getLength());
    }

    return this.angle;
  }

  /**
   * renderIn
   * Appends a <div> element the given drawingContainer, then moves and rotates the <div>
   * to properly to join nodeA and nodeB, that are provided in the constructor.
   *
   * The result is a straight line connecting the two nodes.
   *
   * @param {HTMLElement} drawingContainer
   * @return {void}
   */
  public renderIn(drawingContainer: HTMLElement) {
    const htmlLink = document.createElement("div");
    htmlLink.style.transformOrigin = "top left";
    htmlLink.style.transform = `translate3d(${this.start.x}px, ${this.start.y}px, 0) rotate3d(0, 0, 1, ${this.getAngle()}rad)`;
    htmlLink.style.width = `${this.getLength().toFixed(3)}px`;

    htmlLink.className = TreeLink.htmlClass;

    drawingContainer.append(htmlLink);
  }
}
